<div class="account-identity-header" *ngIf="member$ | async as member">
  <div class="account-identity-left">
    <div class="account-identity-top" *ngIf="userContext$ | async as userContext">
      <div class="account-identity-badge" aria-hidden="true">
        <span class="icon material-icons">workspace_premium</span>
      </div>
      <div class="account-identity-name-block">
        <p class="account-identity-name">{{ member.FirstName }} {{ member.Surname }}</p>
        <p class="account-identity-tier-name">
          {{ userContext.tierName }} {{ 'account.identity.member-suffix' | translate : { fgbdefault: 'member' } }}
        </p>
      </div>
    </div>

    <div class="account-identity-details d-none d-lg-flex" *ngIf="memberCard$ | async as memberCard">
      <div class="account-identity-detail">
        <span class="account-identity-detail-label">
          {{ 'account.identity.member-id' | translate : { fgbdefault: 'Member ID' } }}
        </span>
        <span class="account-identity-detail-value">{{ memberCard.MemberId }}</span>
      </div>
      <div class="account-identity-detail">
        <span class="account-identity-detail-label">
          {{ 'account.identity.tier-detail' | translate : { fgbdefault: 'Tier' } }}
        </span>
        <span class="account-identity-detail-value">
          {{ memberCard.ProductCodeDisplayName || memberCard.ProductCode || '—' }}
        </span>
      </div>
      <div class="account-identity-detail">
        <span class="account-identity-detail-label">
          {{ 'account.identity.fb-discount' | translate : { fgbdefault: 'F&B Discount' } }}
        </span>
        <span class="account-identity-detail-value">{{ formatDiscount(memberCard.DiscountLevel) }}</span>
      </div>
      <div class="account-identity-detail">
        <span class="account-identity-detail-label">
          {{ 'account.identity.general-discount' | translate : { fgbdefault: 'General Discount' } }}
        </span>
        <span class="account-identity-detail-value">{{ formatDiscount(memberCard.RetailDiscountLevel) }}</span>
      </div>
    </div>
  </div>

  <div class="account-identity-right d-none d-lg-flex">
    <div class="account-identity-balances ">
      <div class="account-identity-balance-item">
        <span class="icon material-icons account-identity-balance-icon" aria-hidden="true">loyalty</span>
        <div class="account-identity-balance-text">
          <span class="account-identity-balance-value">{{ points$ | async | number : '1.0-0' }}</span>
          <span class="account-identity-balance-label">
            {{ 'account.identity.your-points' | translate : { fgbdefault: 'Your Points' } }}
          </span>
        </div>
      </div>
      <div class="account-identity-balance-divider"></div>
      <div class="account-identity-balance-item">
        <span class="icon material-symbols-outlined account-identity-balance-icon" aria-hidden="true">money_bag</span>
        <div class="account-identity-balance-text">
          <span class="account-identity-balance-value">{{ credit$ | async | FortressCurrencyPipe }}</span>
          <span class="account-identity-balance-label">
            {{ 'account.identity.credit-detail' | translate : { fgbdefault: 'Credit' } }}
          </span>
        </div>
      </div>
    </div>

    <fgb-ecash-button class="account-identity-payment" [isMemberCard]="true" [cardRouteURL]="'/payment'"></fgb-ecash-button>
  </div>
</div>
